/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type AlertDeleteModalMutationVariables = {|
  id: string
|};
export type AlertDeleteModalMutationResponse = {|
  +warningDelete: ?{|
    +deleted: ?boolean
  |}
|};
export type AlertDeleteModalMutation = {|
  variables: AlertDeleteModalMutationVariables,
  response: AlertDeleteModalMutationResponse,
|};
*/


/*
mutation AlertDeleteModalMutation(
  $id: ID!
) {
  warningDelete(input: {id: $id}) {
    deleted
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "WarningDeletePayload",
    "kind": "LinkedField",
    "name": "warningDelete",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deleted",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AlertDeleteModalMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AlertDeleteModalMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "AlertDeleteModalMutation",
    "operationKind": "mutation",
    "text": "mutation AlertDeleteModalMutation(\n  $id: ID!\n) {\n  warningDelete(input: {id: $id}) {\n    deleted\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'd463549462cba2691f2a328154a05a7b';

module.exports = node;
